'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noAPIOnThemeError = exports.noThemeObjectError = exports.invalidPropertyError = exports.unsupportedBreakpointValuesError = exports.unrecognisedDataPrefixError = exports.missingDataItemKeyError = exports.missingDataNodeError = exports.invalidBreakpointError = exports.invalidBreakpointSyntaxError = exports.noBreakpointWithNameError = exports.noBreakpointAtIndexError = exports.throwMixinError = exports.throwAPIError = exports.throwMQError = exports.throwBreakpointError = exports.throwDataError = exports.throwWhenUndefined = exports.throwLibError = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _errors = require('./const/errors');

var _formatting = require('./utils/formatting');

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

var throwLibError = exports.throwLibError = function throwLibError(message) {
  throw new Error((0, _formatting.joinWithSpace)([_errors.ERROR_PREFIX, message]));
};

var throwPrefixedError = function throwPrefixedError(prefix) {
  return (0, _ramda.compose)(throwLibError, _formatting.joinWithSpace, (0, _ramdaAdjunct.appendFlipped)([prefix]));
};

var throwWhenUndefined = exports.throwWhenUndefined = function throwWhenUndefined(error) {
  return (0, _ramda.when)(_ramdaAdjunct.isUndefined, function () {
    throw error;
  });
};

// -----------------------------------------------------------------------------
// Prefixed Errors
// -----------------------------------------------------------------------------

var throwDataError = exports.throwDataError = throwPrefixedError(_errors.DATA_PREFIX);
var throwBreakpointError = exports.throwBreakpointError = throwPrefixedError(_errors.BREAKPOINTS_PREFIX);
var throwMQError = exports.throwMQError = throwPrefixedError(_errors.MQ_PREFIX);
var throwAPIError = exports.throwAPIError = throwPrefixedError(_errors.API_PREFIX);
var throwMixinError = exports.throwMixinError = throwPrefixedError(_errors.MIXIN_PREFIX);

// -----------------------------------------------------------------------------
// Messages
// -----------------------------------------------------------------------------

var noBreakpointAtIndexError = exports.noBreakpointAtIndexError = function noBreakpointAtIndexError(idx) {
  return 'Couldn\'t resolve breakpoint at index ' + idx;
};

var noBreakpointWithNameError = exports.noBreakpointWithNameError = function noBreakpointWithNameError(name) {
  return 'Couldn\'t resolve breakpoint with name ' + (0, _formatting.wrapWithSingleQuotes)(name);
};

var invalidBreakpointSyntaxError = exports.invalidBreakpointSyntaxError = function invalidBreakpointSyntaxError(name) {
  return 'The syntax you used to describe your breakpoint range was invalid for ' + (0, _formatting.wrapWithSingleQuotes)(name);
};

var invalidBreakpointError = exports.invalidBreakpointError = function invalidBreakpointError(message, args) {
  return message + ' with args: ' + (0, _formatting.printObj)(args);
};

var missingDataNodeError = exports.missingDataNodeError = function missingDataNodeError(name) {
  return 'There is no data node defined named ' + (0, _formatting.wrapWithSingleQuotes)(name);
};

var missingDataItemKeyError = exports.missingDataItemKeyError = function missingDataItemKeyError(nodeName, keyName) {
  return 'No item has been defined for data.' + nodeName + ' named ' + (0, _formatting.wrapWithSingleQuotes)(keyName);
};

var unrecognisedDataPrefixError = exports.unrecognisedDataPrefixError = function unrecognisedDataPrefixError(prefix, validPrefixes) {
  return 'Unrecognised prefix encountered: ' + (0, _formatting.wrapWithSingleQuotes)(prefix) + '. Available prefixes are: ' + (0, _formatting.printObj)(validPrefixes);
};

var unsupportedBreakpointValuesError = exports.unsupportedBreakpointValuesError = function unsupportedBreakpointValuesError(declarations) {
  return 'When using the mq() helper you must supply only a single decaration value but you supplied: ' + (0, _formatting.printObj)(declarations);
};

var invalidPropertyError = exports.invalidPropertyError = function invalidPropertyError(name) {
  return 'API doesn\'t support a property named ' + (0, _formatting.wrapWithSingleQuotes)(name);
};

var noThemeObjectError = exports.noThemeObjectError = function noThemeObjectError() {
  return 'There was no theme object available on the props object';
};

var noAPIOnThemeError = exports.noAPIOnThemeError = function noAPIOnThemeError(value) {
  return 'There was no api function defined on the theme object. Value was: ' + (0, _formatting.printObj)(value);
};


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/errors.js
// module id = 35
// module chunks = 168707334958949